import {NgModule} from '@angular/core';
import {IconComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf
  ],
  exports: [
    IconComponent
  ],
  declarations: [IconComponent],
  providers: [],
})
export class IconComponentModule {
}
